import { render, staticRenderFns } from "./VerificationCreateOrder.vue?vue&type=template&id=403ae780&"
import script from "./VerificationCreateOrder.vue?vue&type=script&lang=js&"
export * from "./VerificationCreateOrder.vue?vue&type=script&lang=js&"
import style0 from "./VerificationCreateOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports